import ContactItem from "./ContactItem";

export {ContactLetterItem as default};

/**
* Contact Letter Item
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ContactLetterItem extends ContactItem {
  /**
   * Contact type
   *
   * @public
   * @readonly
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  type = 'letter';
}